import { Pipe } from '@angular/core';
var IsEqualToPipe = (function () {
    function IsEqualToPipe() {
    }
    IsEqualToPipe.prototype.transform = function (input, other) {
        // tslint:disable-next-line:triple-equals
        return input == other;
    };
    IsEqualToPipe.decorators = [
        { type: Pipe, args: [{ name: 'isEqualTo' },] },
    ];
    /** @nocollapse */
    IsEqualToPipe.ctorParameters = function () { return []; };
    return IsEqualToPipe;
}());
export { IsEqualToPipe };
//# sourceMappingURL=is-equal-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-equal-to.js
// module id = 242
// module chunks = 4